import { getProgramDayFilters } from 'globals/helpers/helpers';
import { FilterGroup } from 'globals/store/filters.data';
import { Program, ProgramTimelineColumns, Session } from 'globals/store/programs.data';

// THIS IS NOW PUBLIC (DUE TO SHAREABLE LOGISTICS) SO MAKE SURE NOT TO HAVE ANY NON PUBLIC IMPORTS
/***
 * This with filter Programs below returns a filtered object with references to the original programs 
 * and sessions it returns (since other services are still accessing / mutating the data)
 * however, the holders of sessions are changed (not the session objects themselves), otherwise
 * the original object itself would be reduced whenever a filter applied
 */

export const filterSession = (session: Session, filters: FilterGroup): boolean => ![
    !filters.sessionLabels || (session.labels && session.labels.some(l => filters.sessionLabels.includes(l)))
].some(passesFilter => !passesFilter)

const checkIds = (type: 'performer' | 'sponsor', filters: FilterGroup, session) => {
  const filter = filters[`${type}s`]
  const ids = session[`${type}Ids`]
  return (filter && filter.length && (ids && ids.some(id => filter.includes(id))))
}

const hasId = (session, filters: FilterGroup) => {
  const idPresent = checkIds('performer', filters, session) || checkIds('sponsor', filters, session)
  return idPresent
}

const noIds = filters => !filters.performers && !filters.sponsors

export const hasIdsOrNoIds = (session, filters: FilterGroup) => noIds(filters) || hasId(session, filters)

export const filterPrograms = (programs: Program[], filters: FilterGroup): Program[] => {

  const { programDayFilters, anyProgramAtLeastPartiallySelected } = getProgramDayFilters(filters)
  const filteredPrograms = programs.filter(p => 
      !anyProgramAtLeastPartiallySelected || ((filters.programs && filters.programs.includes(p.id)) || !!programDayFilters[p.id] || 
      (!!filters.programLabels && (p.labels && p.labels.some(l => filters.programLabels.includes(l)))))
    ).map(p => ({
        ...p,
        sessions: p.sessions.filter((_, i) => !programDayFilters[p.id] || programDayFilters[p.id].has(i+1)).map(day => ({
          ...day,
          sessions: day.sessions
            .filter(sessionId => hasIdsOrNoIds(p.sessions_obj[sessionId], filters))
            .filter(sessionId => filterSession(p.sessions_obj[sessionId], filters))
        }))
    })).filter(p => !!p.sessions.reduce((sessionCount, day) => sessionCount + day.sessions.length, 0))
  return filteredPrograms
}

// I have no idea why the sessions and programs data structures are modified so much in program timeline (why not use the same property names?).  Instead of fixing the root issue and that component, I'm just using any and the structures that KT used to make it

export const filterSnapshotSession = (session: any, filters: FilterGroup): boolean => ![
			!filters.sessionLabels || (session.sess_labels && session.sess_labels.some(l => filters.sessionLabels.includes(l)))
	].some(passesFilter => !passesFilter)

const snapshotProgramFilter = (p: any, filters: FilterGroup): boolean => ![
	() => !filters.programs || filters.programs.includes(p.pID),
	() => !filters.programLabels || (p.prog_labels && p.prog_labels.some(l => filters.programLabels.includes(l))),
].some(passesFilterFunction => !passesFilterFunction())

export const filterSnapshotPrograms = (programs: any[], filters: FilterGroup) => programs.filter(p => snapshotProgramFilter(p, filters))
  	.map(p => ({ 
    ...p, 
    sessions: p.sessions
      .filter(s => hasIdsOrNoIds(s, filters)) 
      .filter(s => filterSnapshotSession(s, filters))
  }))
  .filter(p => p.sessions.length)




export const filterSnapshotTimelines = ({ single_column, multiple_column }: ProgramTimelineColumns, filters: FilterGroup): ProgramTimelineColumns => ({
    single_column: single_column.map(col => ({
      ...col, 
      sessions: col.sessions
        .filter(s => hasIdsOrNoIds(s, filters)) 
        .filter(s => filterSnapshotSession(s, filters))
        .filter(s => snapshotProgramFilter(s, filters)) // single_column timeline sessions have both pID and prog_labels on them
    })).filter(col => col.sessions.length),
    multiple_column: multiple_column.map(col => ({
      ...col,
      programs: filterSnapshotPrograms(col.programs, filters)
    })).filter(col => col.programs.length)
  })